import { notifyMutationError } from '@inquiries/-lib/handleInquiryCompletedError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { InquiryAssignResponse } from 'backend/types'
import { toast } from 'sonner'
import type { CreateInquiryAssignRequest } from '@/lib/apiClients/inquiries'
import { createInquiryAssign } from '@/lib/apiClients/inquiries'
import { queryKeys } from '@/lib/queryKeys'

interface UseCreateInquiryAssignOptions {
  onSuccess?: (data: InquiryAssignResponse) => void
  onError?: (error: Error) => void
}

export function useCreateInquiryAssign(inquiryId: number, options: UseCreateInquiryAssignOptions = {}) {
  const { onSuccess, onError } = options
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreateInquiryAssignRequest) => {
      return createInquiryAssign(inquiryId, data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.assigns(inquiryId) })
      toast.success('アサインを作成しました')
      onSuccess?.(data)
    },
    onError: (error: Error) => {
      notifyMutationError(error, 'アサインの作成に失敗しました')
      onError?.(error)
    },
  })
}
